import { render, staticRenderFns } from "./AddressLookupForm.vue?vue&type=template&id=4a9971b0&scoped=true&"
import script from "./AddressLookupForm.vue?vue&type=script&lang=js&"
export * from "./AddressLookupForm.vue?vue&type=script&lang=js&"
import style0 from "./AddressLookupForm.vue?vue&type=style&index=0&id=4a9971b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9971b0",
  null
  
)

export default component.exports